import { render, staticRenderFns } from "./part-list-ordered.vue?vue&type=template&id=f38a16ec&scoped=true"
import script from "./part-list-ordered.vue?vue&type=script&lang=js"
export * from "./part-list-ordered.vue?vue&type=script&lang=js"
import style0 from "./part-list-ordered.vue?vue&type=style&index=0&id=f38a16ec&prod&lang=css"
import style1 from "./part-list-ordered.vue?vue&type=style&index=1&id=f38a16ec&prod&lang=scss"
import style2 from "./part-list-ordered.vue?vue&type=style&index=2&id=f38a16ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38a16ec",
  null
  
)

export default component.exports